export default "__VITE_ASSET__7b9a8bf9__"